import * as React from 'react';
import { Modal, Button, message } from 'antd';
import { withRouter } from 'react-router';
import { tokens } from 'src/design-system';
import {
  getInquiryEditRoute,
  getDuplicateInquiryRoute,
} from 'src/routing/utils';

class EditInquiryModal extends React.PureComponent<any, any> {

  handleEditOk = () => {
    const { inquiryId, history, handleOk, heading } = this.props;
    if (heading === 'Edit') {
      history.push(getInquiryEditRoute(inquiryId), 'detail');
    } else {
      history.push(getDuplicateInquiryRoute(inquiryId), 'detail');
    }
    handleOk();
  }

  render() {
    const { visible, handleCancel } = this.props;
    return <Modal
      title={`${this.props.heading} Inquiry`}
      visible={visible}
      onOk={this.handleEditOk}
      onCancel={handleCancel}
      okText="Yes"
      cancelText="No"
      footer={[
        <Button key="back" onClick={handleCancel}>
          No
        </Button>,
        <Button key="submit" type="primary" onClick={this.handleEditOk}
        style={{ background: tokens.colors.primary, border: tokens.colors.primary }}>
          Yes
        </Button>,
      ]} ><p>{(this.props.heading === 'Edit') ?
        'Editing this enquiry would make bids received invalid, Are your sure, you want to edit?' :
        'Are you sure you want to Create Duplicate of this inquiry'}</p>
    </Modal>;
  }
}
export default withRouter(EditInquiryModal);
